import { fetch } from '@atlassian/eoc-fetch';
import { urls } from '../../../common/constants/urls';
const getScheduleRights = teamId => {
  return fetch(urls.schedules.teams.teamId.rights.url({
    teamId
  }));
};
const createSchedule = ({
  description,
  name,
  teamId,
  timezone
}) => {
  return fetch(urls.schedules.url(), {
    method: 'POST',
    body: {
      description,
      name,
      teamId,
      timezone,
      // Created schedules are enabled by default
      enabled: true
    }
  });
};
const cloneSchedule = ({
  description,
  name,
  enabled,
  timezone,
  teamId,
  scheduleId
}) => {
  return fetch(urls.schedules.scheduleId.clone.url({
    scheduleId
  }), {
    method: 'POST',
    body: {
      description,
      name,
      enabled,
      timezone,
      teamId
    }
  });
};
export const endpoints = {
  createSchedule,
  getScheduleRights,
  cloneSchedule
};